// src/FDCalculator.js
import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Register necessary components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const FDCalculator = () => {
  const [totalInvestment, setTotalInvestment] = useState(100000);
  const [rateOfInterest, setRateOfInterest] = useState(5);
  const [timePeriod, setTimePeriod] = useState(5);
  const [investedAmount, setInvestedAmount] = useState(0);
  const [estimatedReturn, setEstimatedReturn] = useState(0);
  const [totalValue, setTotalValue] = useState(0);

  // const calculateFD = () => {
  //   const interestRate = rateOfInterest / 100;
  //   const estimatedReturn = totalInvestment * Math.pow(1 + interestRate / 1, 1 * timePeriod) - totalInvestment;
  //   const totalValue = totalInvestment + estimatedReturn;

  //   setInvestedAmount(totalInvestment);
  //   setEstimatedReturn(estimatedReturn.toFixed(2));
  //   setTotalValue(totalValue.toFixed(2));
  // };
  const calculateFD = () => {
    const principal = totalInvestment;
    const r = rateOfInterest; // annual interest rate in %
    const n = 4; // compounding quarterly
    const t = timePeriod;
  
    const amount = principal * Math.pow(1 + r / (n * 100), n * t);
    const estimatedReturn = amount - principal;
  
    setInvestedAmount(principal);
    setEstimatedReturn(estimatedReturn.toFixed(2));
    setTotalValue(amount.toFixed(2));
  };
  
  const handleTotalInvestmentChange = (e) => {
    const value = e.target.value;
    setTotalInvestment(value === '' ? 0 : parseInt(value));
  };

  const handleRateOfInterestChange = (e) => {
    const value = e.target.value;
    setRateOfInterest(value === '' ? 0 : parseFloat(value));
  };

  const handleTimePeriodChange = (e) => {
    const value = e.target.value;
    setTimePeriod(value === '' ? 0 : parseInt(value));
  };

  const data = {
    labels: ['Invested Amount', 'Estimated Return'],
    datasets: [
      {
        label: 'FD Breakdown',
        data: [investedAmount, estimatedReturn],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'What is the purpose of an FD calculator?',
        answer: 'It helps estimate the maturity amount and interest earnings from a fixed deposit investment.',
      },
      {
        question: 'Is the FD calculator accurate?',
        answer: "Yes, but it's based on standard inputs. Final figures may vary depending on bank compounding methods and TDS.",
      },
      {
        question: 'How is compound interest calculated in an FD?',
        answer: 'Compound interest is calculated on both the principal and accrued interest, usually quarterly.',
      },
      {
        question: 'Can I use an FD calculator for tax-saving FDs?',
        answer: 'Yes, though remember tax-saving FDs have a fixed 5-year tenure and tax deduction under Section 80C.',
      },
      {
        question: 'Are senior citizen FDs calculated differently?',
        answer: 'No, but you can input the higher interest rate applicable to seniors into the calculator.',
      },
      {
        question: 'Can I compare two FDs using the calculator?',
        answer: 'Yes, run calculations separately using different interest rates and tenures to compare.',
      },
      {
        question: 'Is the FD calculator free to use?',
        answer: 'Yes, most online FD calculators are free and require no registration.',
      },
      {
        question: 'Can I calculate FD returns for NBFCs?',
        answer: 'Absolutely. Just enter the rate and tenure provided by the NBFC.',
      },
      {
        question: 'Does the FD calculator show post-tax returns?',
        answer: 'Generally, it shows pre-tax returns. You need to manually adjust for tax based on your income slab.',
      },
      {
        question: 'What is the maximum tenure allowed in FD calculators?',
        answer: 'Most allow up to 10 years, in line with standard bank offerings.',
      },
      {
        question: 'Can I calculate monthly interest using the FD calculator?',
        answer: 'Some calculators allow non-cumulative (monthly payout) options—look for this feature.',
      },
      {
        question: 'What input format is required for tenure?',
        answer: 'It varies—some need months, others allow years or custom days.',
      },
      {
        question: 'Can I include TDS in the calculation?',
        answer: 'Some advanced calculators provide a post-TDS view. Otherwise, deduct TDS manually.',
      },
      {
        question: 'What happens when I break my FD early?',
        answer: 'The bank may apply a lower interest rate and charge a penalty. Calculators usually don’t reflect this.',
      },
      {
        question: 'Can I save or print my FD calculation results?',
        answer: 'Most tools allow you to download or screenshot the results for future reference.',
      },
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>

<Helmet>
         <title>FD Calculator- Fixed Deposit Intrest calculator Online At TheFinmaster</title>
        <meta  name='description' content='RD Calculator - FD Calculator Online - Use this Fixed Deposit Calculator to calculate maturity value and the amount of interest earned. | TheFinmaster'/>
        <meta name='keywords' content='fd calculator online, online fixed deposit calculator, calculate recurring deposit interest online, fd calculator sbi online, sbi online fd interest calculator' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/fd-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
</Helmet>
<nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">FD Calculator</span>
        </li> 
      
      </ol>
    </nav>
    <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md ">
      <h1 className="text-2xl font-bold mb-4">Fixed Deposit Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Total Investment</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={totalInvestment}
                onChange={handleTotalInvestmentChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {totalInvestment.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={totalInvestment}
              onChange={(e) => setTotalInvestment(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (p.a.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={rateOfInterest}
                onChange={handleRateOfInterestChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{rateOfInterest} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              step="0.1"
              value={rateOfInterest}
              onChange={(e) => setRateOfInterest(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Time Period (years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="50"
                value={timePeriod}
                onChange={handleTimePeriodChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{timePeriod} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="50"
              value={timePeriod}
              onChange={(e) => setTimePeriod(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateFD}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Invested Amount: ₹ {investedAmount.toLocaleString()}</p>
            <p>Estimated Return: ₹ {estimatedReturn.toLocaleString()}</p>
            <p>Total Value: ₹ {totalValue.toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is a Fixed Deposit?
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            A Fixed Deposit is a financial instrument provided by banks and Non-Banking Financial Companies (NBFCs), where you deposit a lump sum amount for a fixed tenure at a predetermined interest rate. Over the chosen period, your money earns interest and is returned with the principal at maturity.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            The tenure can range from as short as 7 days to as long as 10 years. Once you invest in an FD, the interest rate remains fixed, regardless of market fluctuations, making it a safe and predictable investment option.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Choose Fixed Deposits?
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Guaranteed Returns:</strong> FDs are known for offering fixed, guaranteed returns on your investment. Once you lock in your money, you are assured of the agreed interest rate, unlike market-linked instruments such as mutual funds or stocks.</li>
              <li><strong>Higher Interest Rates Than Savings Accounts:</strong> FDs generally offer better interest rates than regular savings accounts, helping your idle money grow faster. Senior citizens often enjoy additional interest of 0.25% to 0.50%.</li>
              <li><strong>Capital Protection:</strong> Your investment amount (principal) is secure. Banks in India are covered under the Deposit Insurance and Credit Guarantee Corporation (DICGC) which insures deposits up to ₹5 lakh per account holder per bank.</li>
              <li><strong>Flexible Tenure Options:</strong> Choose a tenure that suits your needs—from a few days to several years. Short-term FDs are great for temporary savings, while long-term FDs help build wealth over time.</li>
              <li><strong>Loan Against FD:</strong> In emergencies, you can avail a loan against your FD (up to 90% of the deposit amount), allowing liquidity without breaking the FD prematurely.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does an FD Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              When you invest in a Fixed Deposit, your money is locked in for a chosen period. The bank pays interest—either periodically or at maturity—depending on your selection. At the end of the tenure, you receive your principal plus the accumulated interest.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              There are two types of interest calculations:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Simple Interest FD:</strong> Interest is calculated only on the principal.</li>
              <li><strong>Compound Interest FD:</strong> Interest is calculated on the principal and the accrued interest over time, resulting in higher earnings.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an FD Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An FD Calculator is a digital tool that estimates the maturity amount and total interest earned on your fixed deposit. It automates the calculation process and helps you make better financial decisions.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              All you need to enter are:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Investment amount</li>
              <li>Interest rate</li>
              <li>Tenure (in months or years)</li>
              <li>Type of interest (simple or compound)</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              The Formula to Determine FD Maturity Amount
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              There are two types of FD that you may avail of – simple interest FD and compound interest FD.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The fixed deposit calculator for <strong>simple interest FD</strong> uses the following formula:
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>M = P + (P x r x t/100)</strong>, where –
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal amount that you deposit</li>
              <li>r is the rate of interest per annum</li>
              <li>t is the tenure in years</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong> If you deposit a sum of Rs. 1,00,000 for 5 years at 10% interest, the equation reads –
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              M = Rs. 1,00,000 + (1,00,000 x 10 x 5/100) = Rs. 1,50,000
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For <strong>compound interest FD</strong>, the FD return calculator uses the following formula:
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>M = P x (1 + i/100)^t</strong>, where –
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal amount</li>
              <li>i is the rate of interest per period</li>
              <li>t is the tenure</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong> If you take the same variables, the compound interest FD will accrue:
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              M = Rs. 1,00,000 x (1 + 10/100)^5 = Rs. 1,61,051
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using an FD Calculator
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant Results:</strong> No need for manual or formula-based calculations. Get quick insights into your future returns.</li>
              <li><strong>Easy Comparison:</strong> Compare interest rates across banks and NBFCs to choose the most profitable investment.</li>
              <li><strong>Personalized Planning:</strong> Adjust the inputs to simulate different investment scenarios and plan your finances smartly.</li>
              <li><strong>Better Financial Clarity:</strong> Knowing your estimated returns in advance helps you allocate funds for future needs like education, travel, emergencies, or retirement.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Types of Fixed Deposits
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Standard Fixed Deposit:</strong> Traditional FD where you invest a lump sum for a fixed tenure and receive returns at maturity.</li>
              <li><strong>Tax-Saving Fixed Deposit:</strong> Offers a deduction under Section 80C of the Income Tax Act (up to ₹1.5 lakh). Comes with a mandatory 5-year lock-in period.</li>
              <li><strong>Recurring Deposit (RD):</strong> A variant where you deposit a fixed amount every month. Ideal for people with a regular income who want to save gradually.</li>
              <li><strong>Senior Citizen Fixed Deposit:</strong> Specifically designed for people aged 60+, offering a higher interest rate and flexible payout options.</li>
              <li><strong>Cumulative vs Non-Cumulative FDs:</strong>
                <ul className="list-disc pl-6">
                  <li><strong>Cumulative:</strong> Interest is paid at maturity (compounded quarterly/yearly).</li>
                  <li><strong>Non-Cumulative:</strong> Interest is paid out monthly, quarterly, or annually.</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How to Use an FD Calculator Effectively
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using an FD calculator is simple, but to maximize its utility, follow these steps:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Define your investment amount:</strong> Decide how much you want to invest based on your goals.</li>
              <li><strong>Select a tenure:</strong> Choose a duration depending on your liquidity needs and risk tolerance.</li>
              <li><strong>Enter the interest rate:</strong> Use the rate offered by the specific bank/NBFC.</li>
              <li><strong>Choose interest type:</strong> Simple or compound—depending on your FD type.</li>
              <li><strong>Evaluate results:</strong> The tool displays the maturity value and interest earned.</li>
              <li><strong>Compare:</strong> Try different institutions and tenures to find the best option for your goal.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Planning Your Finances with an FD Calculator
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Fixed Deposits may not generate high returns like equities, but they are ideal for:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Emergency funds</li>
              <li>Retirement planning</li>
              <li>Short-term goals (vacations, purchases)</li>
              <li>Tax-saving strategies</li>
              <li>Diversifying a conservative portfolio</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using an FD calculator helps align these goals with appropriate tenures and interest rates.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Tips for Maximizing Your FD Returns
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Compare before investing:</strong> Rates vary across banks and NBFCs.</li>
              <li><strong>Avoid premature withdrawals:</strong> Breaking the FD early results in lower interest and penalties.</li>
              <li><strong>Reinvest wisely:</strong> At maturity, reinvesting your corpus helps compound wealth.</li>
              <li><strong>Split large amounts:</strong> Use multiple FDs with different maturity periods (laddering) for better liquidity and returns.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Factors to Consider Before Investing in FDs
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Interest Rate Trends:</strong> Lock in FDs when rates are high.</li>
              <li><strong>Inflation Impact:</strong> FD returns should ideally beat inflation for real gains.</li>
              <li><strong>Taxation:</strong> Interest earned is taxable. If interest exceeds ₹40,000 (₹50,000 for seniors), TDS is applicable.</li>
              <li><strong>Premature Closure Terms:</strong> Understand withdrawal penalties and interest deductions.</li>
              <li><strong>Auto-Renewal Option:</strong> Some banks auto-renew FDs on maturity. Keep track to avoid locked-in funds.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Use Cases: Who Should Use FD Calculators?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              FD Calculators are useful for:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Salaried individuals planning secure savings</li>
              <li>Retirees seeking stable returns</li>
              <li>Parents saving for child’s education</li>
              <li>Business owners parking surplus funds</li>
              <li>Anyone wanting to visualize returns before investing</li>
            </ul>
          </div>

          <h1 className="text-xl font-medium text-gray-700 mt-4">
            “Looking to grow your savings securely? Use TheFinMaster to plan your Fixed Deposits and achieve your financial goals!”
          </h1>
        </div>

        <div className="w-full md:w-1/3 p-4">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
              <h2 className="text-lg font-semibold ">Popular Categories</h2>
            </div>
            <div className="p-2 ">
            <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                {/* {moreCategories.map(category => (
          <Link key={category.id} to={`/category/${category.id}`}>
            <li className="py-2 border-b border-gray-300">{category.name}</li>
          </Link>
        ))} */}
              </ul>
            </div>
          </div>

        </div>

      </div>
      <div className="max-w-4xl mx-auto py-6 mt-10 px-2">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default FDCalculator;
